import { render, staticRenderFns } from "./Overtime.vue?vue&type=template&id=ffbaa720&scoped=true&"
import script from "./Overtime.vue?vue&type=script&lang=js&"
export * from "./Overtime.vue?vue&type=script&lang=js&"
import style0 from "./Overtime.vue?vue&type=style&index=0&id=ffbaa720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbaa720",
  null
  
)

export default component.exports